import React, { ChangeEvent, useCallback, useState ,useEffect} from 'react';
import MembOtpRegChkApi from "Apis/MembOtpRegChkApi";
import { Navigate, useNavigate, useOutletContext,useLocation } from "react-router-dom";
import"Assets/css/MembFind.css";
import { Helmet } from "react-helmet-async";
import MembPasswdChngApi from 'Apis/MembPasswdChngApi';
import useRecaptcha from 'Utils/useRecaptcha';
import MgpStore from 'Stores/Store';
import ApiResultModal from "Components/ApiResultModal";
import UseLangLstQuery from "Apis/LangTxtInqApi";




const AppMembPagePasswdChngInputUi = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const membAccnDtlInfo = location.state?.membAccnDtlInfo;
    const [membId,setMembId] = useState(membAccnDtlInfo?.membId);
    const [idntMthdCd,setIdntMthdCd] = useState(membAccnDtlInfo?.idntMthdCd);
    const [passwdInputVal,setPasswdInputVal] = useState("");
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const { getToken } = useRecaptcha();
    const [emlAthnCdValState,setEmlAthnCdValState]=useState("");
    const [passwdChkVal,setPasswdChkVal] = useState("");
    const [passwdAlertTxt,setPasswdAlertTxt] = useState("");
    const [passwdAlertState,setPasswdAlertState] = useState("N");
    const [passwdChkAlertTxt,setPasswdChkAlertTxt] = useState("");
    const [passwdChkAlertState,setPasswdChkAlertState] = useState("N");
    const [passwdRsltVal,setPasswdRsltVal] = useState<string>("");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
    const passWdRole = /^(?=.*[a-z])(?=.*[ !@$%^&*_~-])[A-Za-z\d !@$%^&*_~-]{8,30}$/;
     const PasswdInputHandler = (event:ChangeEvent<HTMLInputElement>) => {
            setPasswdRsltVal(""); // 비밀번호 입력 시 결과값 초기화
            const nextPasswd = event.currentTarget.value;
            setPasswdInputVal(nextPasswd);

            // 액션 시 기존 라벨 초기화
            setPasswdAlertState("N");
            setPasswdAlertTxt("");
            setPasswdChkAlertState("N");
            setPasswdChkAlertTxt("");

            // 비밀번호 필드 라벨 표시
            if(nextPasswd.length === 0) {
                setPasswdAlertTxt(langData.MYPAGE_MEMB_PASSWD_INPUT_DESC_00);
            } else if(!passWdRole.test(nextPasswd)) {
                setPasswdAlertTxt(langData&&langData.MEMB_FIND_PASSWD_INPUT_DESC_01);
            } else {
                setPasswdAlertTxt("");
            }
            
            // 비밀번호가 변경되면 비밀번호 확인 상태도 초기화
            if(passwdChkVal.length > 0) {
                if(!passWdRole.test(nextPasswd)) {
                    setPasswdChkAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_CHK_DESC_00);
                } else if(nextPasswd !== passwdChkVal) {
                    setPasswdChkAlertTxt(langData.MYPAGE_MEMB_PASSWD_INPUT_LBL_00);
                } else {
                    setPasswdChkAlertState("Y");
                    setPasswdChkAlertTxt(langData.MYPAGE_MEMB_PASSWD_INPUT_LBL_01);
                }
            }
        }
    const PasswdChkHandler = (event:ChangeEvent<HTMLInputElement>) => {
        setPasswdRsltVal(""); // 비밀번호 확인 입력 시 결과값 초기화
        const nextPasswdChk = event.currentTarget.value;
        setPasswdChkVal(nextPasswdChk);

        // 액션 시 확인 라벨 초기화
        setPasswdChkAlertState("N");
        setPasswdChkAlertTxt("");
        
        // 비밀번호 확인 필드가 비워진 경우
        if(nextPasswdChk.length === 0) {
            setPasswdChkAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_CHK_DESC_00);
            //비밀번호를 다시 한번 입력해주세요.
            return;
        }
        
        if(!passWdRole.test(passwdInputVal)){
            // 2차 입력칸은 2차 전용 안내만 노출
            setPasswdChkAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_CHK_DESC_00);
            return;
        }else {
            if(passwdInputVal.length !=0 && passwdInputVal == nextPasswdChk ) {
                setPasswdChkAlertState("Y");
                setPasswdChkAlertTxt(langData.MYPAGE_MEMB_PASSWD_INPUT_LBL_01);
                //입력한 비밀번호가 일치합니다.
            }
            else if (passwdInputVal.length ==0) {
                setPasswdChkAlertState("N");
                setPasswdChkAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_CHK_DESC_00);
                //비밀번호를 다시 한번 입력해주세요.
            }
            else {
                setPasswdChkAlertState("N");
                setPasswdChkAlertTxt(langData.MYPAGE_MEMB_PASSWD_INPUT_LBL_00);
                //입력한 비밀번호가 일치하지 않습니다.
            }
        }
    }
const PasswdChkFunc = () => {
    // 액션 시 확인 라벨 초기화
    setPasswdChkAlertState("N");
    setPasswdChkAlertTxt("");

        if(passwdChkVal.length === 0) {
            return;
        }
    
        if(!passWdRole.test(passwdInputVal)){
            // 2차 입력칸은 2차 전용 안내만 노출
            setPasswdChkAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_CHK_DESC_00);
            return;

        }else {
            if(passwdInputVal.length !=0 && passwdInputVal == passwdChkVal ) {
                setPasswdChkAlertState("Y");
                setPasswdRsltVal(passwdChkVal);
                setPasswdChkAlertTxt(langData.MYPAGE_MEMB_PASSWD_INPUT_LBL_01);
                // 입력한 비밀번호가 일치합니다.
            }
            else if (passwdInputVal.length ==0) {
                setPasswdChkAlertState("N");
                setPasswdChkAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_CHK_DESC_00);
                //비밀번호를 다시 한번 입력해주세요.
            }
            else {
                setPasswdChkAlertState("N");
                setPasswdRsltVal("");
                setPasswdChkAlertTxt(langData.MYPAGE_MEMB_PASSWD_INPUT_LBL_00);
                // 입력한 비밀번호가 일치하지 않습니다.
            }
        }
    }
    
    const passWdChngFunc = async (loginId:string,passWd:string,emlAthnCd:string|null)=> {
        if(passWd === ""||passWd === null||!passWdRole.test(passWd)) {
            // 제출 직전에 한 번 더 현재 입력값 기준으로 검증
            if(passwdInputVal.length > 0 || passwdChkVal.length > 0) {
                setPasswdAlertState("N");
                setPasswdChkAlertState("N");

                if(passwdInputVal.length === 0) {
                    setPasswdAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_INPUT_DESC_00);
                } else if(!passWdRole.test(passwdInputVal)) {
                    setPasswdAlertTxt(langData&&langData.MEMB_FIND_PASSWD_INPUT_DESC_01);
                } else {
                    setPasswdAlertTxt("");
                }

                if(passwdChkVal.length === 0) {
                    setPasswdChkAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_CHK_DESC_00);
                } else if(passwdInputVal !== passwdChkVal) {
                    setPasswdChkAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_INPUT_LBL_00);
                } else {
                    setPasswdChkAlertState("Y");
                    setPasswdChkAlertTxt(langData&&langData.MYPAGE_MEMB_PASSWD_INPUT_LBL_01);
                }
                return false;
            }

            // 실제로 입력이 전혀 없을 때만 모달 노출
            openResultModal(langData&&langData.MYPAGE_MEMB_PASSWD_INPUT_DESC_00);
            return false;
        }
        try {
            const token = await getToken('memb_passwd_chng');
            const resp = await MembPasswdChngApi(loginId, passWd, token, idntMthdCd, emlAthnCd);
            if(resp.apiHdr.code=="ATHN2100") {
                openResultModal(
                    langData&&langData.MYPAGE_MEMB_EML_ATHN_ERROR_00,
                    () => navigate("/Connect/MyPage/passwdchng")
                );
            }
            if(resp.apiHdr.code=="MEMB0000") {
                openResultModal(
                    langData&&langData.MYPAGE_FIND_PASSWD_RSLT_LPOP_00,
                    () => navigate("/Connect/AppStrt",{ state: { pageCd: "mypage" }, replace:true })
                );
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('reCAPTCHA token failed', e);
        }
    }
    useEffect(() => {
        setPasswdAlertTxt("");
        setPasswdAlertState("N");
        setPasswdChkAlertTxt("");
        setPasswdChkAlertState("N");
        
    }, [langData]);
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
            confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            app="app"
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_PASSWD_CHNG_BTN_00}`}</title>
        </Helmet>
        <div className="loginInputWrap">
            <div className="membJoinForm">
                    <div className="membFindTitl membFindRsltTitl">
                        <h1>{langData&&langData.MYPAGE_MENU_PASSWD_CHNG_BTN_00}</h1>
                    </div>
                    <div className="membFindRsltTxtWrap membFindPwRsltTxtWrap">
                        <p>
                            {langData&&langData.MYPAGE_FIND_PASSWD_RSLT_DESC_00}
                        </p>
                    </div>

                    <div className="membFindRsltUl membFindPwRsltUl">
                        <ul className="pt30">
                            <li>
                                <input type="password" name='PasswdInput' className='membJoinFormInput' placeholder={`${langData&&langData.MYPAGE_MEMB_PASSWD_INPUT_DESC_00}`} id='passwdInput' onChange={PasswdInputHandler}/>
                                {/* 비밀번호를 입력해주세요. */}
                                <span className={passwdAlertState == "Y"?"joinInputDesc colGreen":"joinInputDesc"}>{passwdAlertTxt || '\u00A0'}</span>
                            </li>
                            <li>
                                <input type="password" name='PasswdInput' className='membJoinFormInput' placeholder={`${langData&&langData.MYPAGE_MEMB_PASSWD_CHK_DESC_00}`} id='passwdChkInput' onChange={PasswdChkHandler} onBlur={() => PasswdChkFunc()}/>
                                {/*비밀번호를 다시 한번 입력해주세요.  */}
                                <span className={passwdChkAlertState == "Y"?"joinInputDesc colGreen":"joinInputDesc"}>{passwdChkAlertTxt || '\u00A0'}</span>
                            </li>
                        </ul>
                    </div>

                <div className="nextBtnWrap">
                    <button onClick={()=>passWdChngFunc(membId,passwdRsltVal,emlAthnCdValState)} className="loginBtn">
                        <p>{langData&&langData.MYPAGE_PASSWD_CHNG_MAIN_BTN_00}</p>
                    </button>
                </div>
            </div>
        </div>

        {/* reCAPTCHA provided at app root; per-page provider removed */}
        </>
    )
}

export default AppMembPagePasswdChngInputUi;